import AccordionSetup from "../AccordionSetup";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { useState } from "react";
import { EventDto } from "../../../interfaces/IEvent";
import { EventType } from "../../../interfaces/IEventEnums";
import { IncidentDetails } from "./Incident/IncidentDetails";
import { GenericDetails } from "./Generic/GenericDetails";
import { PlannedWorkDetails } from "./PlannedWork/PlannedWorkDetails";
import UpdateGenericDetails from "./Generic/UpdateGenericDetails";
import UpdatePlannedWorkDetails from "./PlannedWork/UpdatePlannedWorkDetails";
import UpdateIncidentDetails from "./Incident/UpdateIncidentDetails";

interface DetailsProps {
    viewEvent: EventDto;
    onUpdateEventView: (eventId: string) => void;
}

function DetailsContainer({viewEvent, onUpdateEventView}: DetailsProps){
    const [open, setOpenEditDetails] = useState(false);

    const handleOpenEditDetailsDialog = () => {
        setOpenEditDetails(true);
    };

    const handleClose = () => {
        setOpenEditDetails(false);
        onUpdateEventView(viewEvent.id);
    };

    return (
        <>
            <AccordionSetup 
                title="Detaljer" 
                icon={<SettingsOutlinedIcon />}
                actionIcon={<EditOutlinedIcon />}
                action={handleOpenEditDetailsDialog}
                contentHeight={2000}
            >
                {viewEvent.type === EventType.Generell &&
                <>
                    <GenericDetails
                        viewEvent={viewEvent}
                        onUpdateEventView={onUpdateEventView}
                    />
                    <UpdateGenericDetails
                        viewEvent={viewEvent}
                        open={open}
                        onClose={handleClose}
                    />
                </>
                }
                {viewEvent.type === EventType.Planlagt &&
                <>
                    <PlannedWorkDetails
                        viewEvent={viewEvent}
                        onUpdateEventView={onUpdateEventView}
                    />
                    <UpdatePlannedWorkDetails
                        viewEvent={viewEvent}
                        open={open}
                        onClose={handleClose}
                    />
                </>
                }
                {viewEvent.type === EventType.Fellesfeil &&
                <>
                    <IncidentDetails
                        viewEvent={viewEvent}
                        onUpdateEventView={onUpdateEventView}
                    />
                    <UpdateIncidentDetails
                        viewEvent={viewEvent}
                        open={open}
                        onClose={handleClose}
                    />
                </>
                }
            </AccordionSetup>
        </>
    );
}

export default DetailsContainer;